import React, { lazy, memo } from "react";
import { useTranslation } from "react-i18next";
import { Controller, useFormContext, useWatch } from "react-hook-form";
// import InputField from "Components/formControls/HookFields/InputField";
import { Box } from "@material-ui/core";
import { get } from "lodash";
import { useOrganizationValidation } from "Validations/Organization/useOrganizationValidation";
const InputField = lazy(() =>
  import("Components/formControls/HookFields/InputField")
);

const Title = ({ name, showLabel, data, index }) => {
  const { t } = useTranslation();
  const {
    register,
    control,
    formState: { errors },
    watch,
    setError,
    setValue,
  } = useFormContext();
  const { listOfStrength } = watch("configuration.strengths");
  const { strengthTitleError } = useOrganizationValidation();
  const nameUpdated = index >= 0 ? `${name}.${index}` : `${name}`;
  return (
    <Box mr={1} className="strength-title">
      <Controller
        register={register(`${nameUpdated}.name`, strengthTitleError)}
        name={`${nameUpdated}.name`}
        control={control}
        render={({ field }) => {
          const { onChange } = field;
          return (
            <InputField
              label={showLabel ? "Strength title" : null}
              placeholder={"Enter title..."}
              error={get(errors, `${nameUpdated}.name.message`, "")}
              value={data?.name || ""}
              onChange={(e) => {
                onChange(e.target.value.trimLeft());
              }}
              onBlur={(e) => {
                const checkDuplicateName = listOfStrength?.find(
                  (res, idx) =>
                    idx !== index &&
                    res.name.toLowerCase() ===
                      e.target.value.trimLeft()?.toLowerCase()
                );
                if (checkDuplicateName?.name)
                  setError(`${nameUpdated}.name`, {
                    type: "Custom",
                    message: "Strength already present",
                  });
                else setValue(`${nameUpdated}.action`, "upsert");
              }}
            />
          );
        }}
      />
    </Box>
  );
};

export default memo(Title);
